export default __webpack_public_path__ + "static/media/OpenWilma.81a80926.png";